import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LinkChainSvg = function LinkChainSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.616 2.249 22 8.633l-5.452 5.452-.959-.96 4.493-4.492-4.466-4.466-4.493 4.493-.959-.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.904 15.386 7.233-7.233.959.959-7.233 7.233z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.411 11.372-4.493 4.493 4.466 4.466 4.493-4.493.959.959-5.452 5.452L2 15.865l5.452-5.452z"
  }));
};
export var LinkChain = function LinkChain(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LinkChainSvg
  }));
};